export default (props, vars) =>
  props?.['rows'] || props?.['value']?.split('\n').length || 2;
